<template>
    <AutoComplete :value="value" @input="onInput" name="ateco_code" id="ateco_code"
    @complete="searchCode($event)" :suggestions="filteredCodes" field="label">
        <template #item="slotProps">
            <div>
                {{slotProps.item.label}}
            </div>
        </template>
    </AutoComplete>
<!-- @item-select="$emit('item-select', selectedCode)" -->
</template>

<script>
import AutoComplete from 'primevue/autocomplete';
import axios from 'axios';

export default {
    components: {
        AutoComplete,
    },
    props: ['value', 'code'],
    created() {
        if (this.code) {
            this.selectedCode = this.code;
        }
    },
    data() {
        return {
            modelValue: null,
            selectedCode: null,
            filteredCodes: null,
        };
    },
    methods: {
        searchCode(event) {
            const text = event.query.toLowerCase();
            axios({
                method: 'get',
                url: route('ateco.index', text),
            }).then(res => {
                this.filteredCodes = res.data;
            }).catch(error => {
                console.log('ERR', error);
            });
        },
        onInput(e) {
            if (typeof e === 'object' && e !== null) {
                this.$emit('input', e.label);
            } else {
                this.$emit('input', e);
            }
        },

    },
}
</script>

<style lang="scss">

    .p-autocomplete {
        width: 100%;
        .p-inputtext {
            width: 100%;
            font-size: 14px !important;
            height: 45px !important;
            padding: 10px 15px !important;
            border-radius: 2px !important;
            transition: 150ms ease-in-out !important;
            font-weight: 400 !important;
            line-height: 1.5 !important;
            color: #495057 !important;
            border: 1px solid #ebebeb !important;
        }

        .p-inputtext:hover {
            border-color: #ebebeb !important;
        }
        .p-inputtext:focus {
            border-color: #F78C31 !important;
            box-shadow: none !important;
        }

    }

</style>
